import React, { FC, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { CurrentUserType } from 'src/ducks/auth'
import routes from 'src/routes'
import PageWithBg from '../../components/PageWithBg'
import config from '../../config'
import MalexLogo from '../../images/backdrops/malex-logo.png'
import arthrex from '../../images/backdrops/arthrex.png'
import SmithNephew from '../../images/backdrops/smithNephew-logo.png'
import Amplitude from '../../utils/amplitudeHelper'
import { StyledLandingPage } from './styled'
const VirtualProductLandingPage: FC<{ currentUser: CurrentUserType }> = ({ currentUser }) => {
  const history = useHistory()

  useEffect(() => {
    document.title = `${config.eventName} | Virtual Product Theatre`
  }, [])

  useEffect(() => {
    Amplitude.visit('Virtual Product Landing Page')
  }, [currentUser.id])

  const handleSmithNephew = () => {
    history.push(routes.smithNephew)
  }

  const handleMalex1 = () => {
    history.push(routes.malexMedicalAsia1)
  }

  const handleMalex2 = () => {
    history.push(routes.malexMedicalAsia2)
  }

  return (
    <>
      <StyledLandingPage>
        <PageWithBg bgImg={config.assets.landing.landscape}>
          <div onClick={handleSmithNephew} className="smithNephew">
            <div className="logo-container">
              <img src={SmithNephew} alt="smith-nephew-logo" />
            </div>
          </div>
          <div onClick={handleMalex1} className="malex-1">
            <div className="logo-container">
              <img src={MalexLogo} alt="smith-nephew-logo" />
            </div>
            <div className="logo-container">
              <img src={arthrex} alt="arthrex-logo" />
            </div>  
          </div>
          <div onClick={handleMalex2} className="malex-2">
            <div className="logo-container">
              <img src={MalexLogo} alt="smith-nephew-logo" />
            </div>
            <div className="logo-container">
              <img src={arthrex} alt="arthrex-logo" />
            </div>
          </div>
        </PageWithBg>
      </StyledLandingPage>
    </>
  )
}

export default VirtualProductLandingPage
